import { MealDetailsConnectorApollo } from '@front-activerse/common-components';
import { MealSiblingsConnectorApollo } from '@front-activerse/common-components';
import { MealReplacementsConnectorApollo } from '@front-activerse/common-components';
import { ReplaceProductConnectorApollo } from '@front-activerse/common-components';
import { SetMealEatenConnectorApollo } from '@front-activerse/common-components';
import { AddMealToFavoritesConnectorApollo } from '@front-activerse/common-components';
import { RemoveMealFromFavoritesConnectorApollo } from '@front-activerse/common-components';
import { RateMealConnectorApollo } from '@front-activerse/common-components';

import MealDetails from './components/DayPlanMealDetails';
import Dish from './components/DayPlanDish';
import IngredientList from './components/DayPlanIngredientList';
import Ingredient from './components/DayPlanIngredient';
import IngredientReplacementList from './components/DayPlanIngredientReplacementList';
import IngredientReplacement from './components/DayPlanIngredientReplacement';
import DietetiansAdvice from './components/DayPlanDietetiansAdvice';

import { useTimestamp } from '@front-activerse/common-components';
import { createDateObject } from '@front-activerse/common-components';
import { useAppContext } from '@front-activerse/common-components';

import { useParams } from 'react-router-dom';

const MealDetailsPage = () => {
  const { date, dietMealId, mealType, userDietSetId, originalMealId } = useParams();
  const { post } = useAppContext();

  const renderIngredientReplacements = (
    replacements,
    productAmountId,
    productId,
    productKey,
    clickAction
  ) =>
    replacements.map((replacement) => (
      <ReplaceProductConnectorApollo
        date={createDateObject(date)}
        userDietSetId={+userDietSetId}
        mealType={+mealType}
        dietMealId={+dietMealId}
        post={post}
        key={+dietMealId * Math.random()}
      >
        {({ replaceProduct }) => (
          <IngredientReplacement
            key={replacement.productId}
            replacementId={replacement.productId}
            name={replacement.name}
            measurements={replacement.measurements}
            replaceProduct={replaceProduct}
            productId={productId}
            productKey={productKey}
            productAmountId={productAmountId}
            replaceProductSuccess={clickAction.closeAndScroll}
            date={date}
          />
        )}
      </ReplaceProductConnectorApollo>
    ));

  const renderIngredientReplacementsList = (
    replacements,
    originalProductId,
    productId,
    productKey,
    original,
    productAmountId,
    clickAction
  ) => (
    <IngredientReplacementList
      shouldRenderOryginalProduct={originalProductId !== productId}
      renderOriginalProduct={() =>
        renderIngredientReplacements(
          [original],
          productAmountId,
          productId,
          productKey,
          clickAction
        )
      }
      hasReplacements={replacements.length > 0}
    >
      {() =>
        renderIngredientReplacements(
          replacements,
          productAmountId,
          productId,
          productKey,
          clickAction
        )
      }
    </IngredientReplacementList>
  );

  const renderIngredients = (ingredients) =>
    ingredients.map((ingredient) => (
      <Ingredient
        key={ingredient.productId}
        name={ingredient.name}
        measurements={ingredient.measurements}
        saleProductVariant={ingredient.saleProductVariant}
        hasReplacement={ingredient.hasReplacement}
        originalProductId={ingredient.original.productId}
        productId={ingredient.productId}
        mealType={mealType}
        productKey={ingredient.key}
        print={false}
      >
        {({ closeAndScroll }) =>
          renderIngredientReplacementsList(
            ingredient.replacements,
            ingredient.original.productId,
            ingredient.productId,
            ingredient.key,
            ingredient.original,
            ingredient.productAmountId,
            { closeAndScroll }
          )
        }
      </Ingredient>
    ));

  const renderIngredientList = (ingredients, portions) => {
    const filteredIngredients = ingredients.filter(
      (ingredient) => !ingredient.category.isSeasoning && !ingredient.category.isOptional
    );

    const onlySeasoningsIngredients = ingredients.filter(
      (ingredient) => ingredient.category.isSeasoning
    );

    const optionalIngredients = ingredients.filter((ingredient) => ingredient.category.isOptional);

    return (
      <IngredientList
        renderIngredients={() => renderIngredients(filteredIngredients)}
        renderOnlySeasoningsIngredients={() => renderIngredients(onlySeasoningsIngredients)}
        renderOptionalIngredients={() => renderIngredients(optionalIngredients)}
        portions={portions}
      />
    );
  };

  const renderDishes = (dishes) =>
    dishes.map((dish) => (
      <Dish
        key={dish.key}
        name={dish.name}
        recipe={dish.recipe}
        recipeNote={dish.recipeNote}
        isFirstOccurrence={dish.isFirstOccurrence}
        isLastOccurrence={dish.isLastOccurrence}
        isPortioned={dish.isPortioned}
        portions={dish.portions}
        portionsTotal={dish.portionsTotal}
      >
        {() => renderIngredientList(dish.ingredients, dish.portionsTotal)}
      </Dish>
    ));

  const dietitiansAdvice = (dishes) => {
    const adviceArray = [];

    dishes.forEach((dish) => {
      dish.ingredients.forEach((ingredient) => {
        if (ingredient.note.title) {
          adviceArray.push({
            title: ingredient.note.title,
            description: ingredient.note.content,
            media: ingredient.note.media,
          });
        }
      });
    });

    if (adviceArray.length > 0) {
      return <DietetiansAdvice advices={adviceArray} />;
    }

    return null;
  };

  const { timestamp1 } = useTimestamp();

  return (
    <MealReplacementsConnectorApollo date={createDateObject(date)}>
      {({ loadDayPlanMealReplacements }) => (
        <SetMealEatenConnectorApollo date={createDateObject(date)}>
          {({ setMealEaten }) => (
            <AddMealToFavoritesConnectorApollo date={createDateObject(date)}>
              {({ addMealToFavorites }) => (
                <RemoveMealFromFavoritesConnectorApollo date={createDateObject(date)}>
                  {({ removeMealFromFavorites }) => (
                    <MealSiblingsConnectorApollo date={date}>
                      {({ ...mealSiblings }) => (
                        <RateMealConnectorApollo>
                          {({ rateMeal }) => (
                            <MealDetailsConnectorApollo
                              userDietSetId={+userDietSetId}
                              mealType={+mealType}
                              dietMealId={+dietMealId}
                            >
                              {({ ...mealData }) => (
                                <MealDetails
                                  {...mealData}
                                  key={timestamp1}
                                  originalMealId={+originalMealId}
                                  date={createDateObject(date)}
                                  loadDayPlanMealReplacements={loadDayPlanMealReplacements}
                                  setMealEaten={setMealEaten}
                                  setId={+userDietSetId}
                                  addMealToFavorites={addMealToFavorites}
                                  removeMealFromFavorites={removeMealFromFavorites}
                                  mealSiblings={mealSiblings}
                                  rateMeal={rateMeal}
                                  loading={mealData.loading || mealSiblings.loading}
                                >
                                  {() => (
                                    <>
                                      {renderDishes(mealData.meal.dishes)}
                                      {dietitiansAdvice(mealData.meal.dishes)}
                                    </>
                                  )}
                                </MealDetails>
                              )}
                            </MealDetailsConnectorApollo>
                          )}
                        </RateMealConnectorApollo>
                      )}
                    </MealSiblingsConnectorApollo>
                  )}
                </RemoveMealFromFavoritesConnectorApollo>
              )}
            </AddMealToFavoritesConnectorApollo>
          )}
        </SetMealEatenConnectorApollo>
      )}
    </MealReplacementsConnectorApollo>
  );
};

export default MealDetailsPage;
